import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SearchPagesService } from '../../core/search-pages.service';

@Component({
  selector: 'search-page-counter-pagination',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './search-page-counter-pagination.component.html',
  styleUrls: ['./search-page-counter-pagination.component.scss'],
})
export class SearchPageCounterPaginationComponent {
  currentPageData = this.searchPagesService.get();

  constructor(private searchPagesService: SearchPagesService) {}

  getDisplayValue(totalResults: number, pageSize: number): { display: number; total: number } {
    const display = totalResults <= pageSize ? totalResults : pageSize;
    return { display, total: totalResults };
  }
}
